<template>
    <div class="app-inner" id="poinsDetail">
         <div class="public-btn-small flex align-cen posta" style="padding-left:0;">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            </div>
             <div class="p-tit-c">
                  <div class="businessList-filter">
                <div class="businessList-filter-list flex align-cen">
                     <div class="businessList-filter-list flex align-cen">
                    <div class="label">积分来源：</div>
                      <div
                            style="color: red; padding-right: 20px; cursor: pointer"
                            @click="allradio"
                            >
                            不限
                            </div>
                        <el-radio v-model="radio" label="签到奖励" @change="gethisInfo">签到奖励</el-radio>
                        <el-radio v-model="radio" label="购物奖励" @change="gethisInfo">购物奖励</el-radio>
                         <el-radio v-model="radio" label="任务获取" @change="gethisInfo">任务获取</el-radio>
                         <el-radio v-model="radio" label="管理员修改" @change="gethisInfo">管理员修改</el-radio>
                         <el-radio v-model="radio" label="购物消耗" @change="gethisInfo">购物消耗</el-radio>
                 </div>
                </div>
     <div class="businessList-filter-list flex align-cen">
        <div class="label">操作时间：</div>
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          @change="dataSuccess"
        >
        </el-date-picker>
      </div>
                  </div>
             </div>
         <div class="public-tit flex align-cen" style="margin:16px 0">
            <div class="public-tit-list">
                <i class="icon-al-user-fill"></i>  用户信息
            </div>
        </div>
         <div class="businessDetail-data-table">
             <el-table
            :data="userinfo"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column prop="loginName" label="用户电话" align="center">
          </el-table-column>
         <el-table-column prop="userName" label="用户昵称" align="center">
          </el-table-column>
         <el-table-column prop="score" label="可用积分" align="center">
          </el-table-column>
           <el-table-column prop="totalScore" label="历史积分" align="center">
          </el-table-column>
           <el-table-column label="成长值" align="center">
          <template>
            暂无
          </template>
          </el-table-column>
             </el-table>
         </div>
           <div class="public-tit flex align-cen" style="margin:16px 0">
            <div class="public-tit-list">
                <i class="icon-al-copy-fill"></i>  积分列表
            </div>
        </div>
         <div class="businessDetail-data-table" style="margin-bottom:50px">
              <el-table
            :data="list"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            class=" businessDetail-data-table1"
            >
             <el-table-column prop="source" label="积分来源" align="center">
          </el-table-column>
           <el-table-column prop="integral" label="积分变化" align="center">
          </el-table-column>
           <el-table-column prop="operateTime" label="时间" align="center">
          </el-table-column>
           <el-table-column prop="operateTime" label="备注" align="center">
            <template  slot-scope="scope">
                {{scope.row.remark || '无'}}
            </template>
          </el-table-column>
              </el-table>
         </div>
    </div>
</template>
<script>
import {scoreList,businessAccountDetail} from "@/api/index/index"  //积分列表、用户详情
export default {
    name:'poinsDetail',
    data() {
        return {
            userinfo:[],
            list:[],
            radio:'',
            value1:'',
            start_time:'',
            end_time:'',
         pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
    created() {
        this.getDetail()
       this.gethisInfo() 
    },
    methods: {
        // 查询
        allradio(){
            this.radio = ''
            this.gethisInfo() 
        },
        // 时间筛选
          dataSuccess(){
             if(this.value1){
             this.start_time = this.value1[0]
            this.end_time = this.value1[1]
            }else{
                 this.start_time =''
                 this.end_time =""
            }
             this.gethisInfo()
        },
        // 获取用户详情
        getDetail(){
            this.userinfo = []
                 businessAccountDetail({
                id:this.$route.query.id
              })
            .then(res => {
                  this.userinfo = [
                    {
                        score:res.data.score,
                        loginName:res.data.loginName,
                        userName:res.data.userName,
                        totalScore:res.data.totalScore,
                        grow:''
                    }
                ]
            })
            .catch(err => {
            })
        },
                       // 获取列表
        gethisInfo(){
            let params = {
                id:this.$route.query.id,
                source:this.radio,
                operateTimeStart:this.start_time,
                operateTimeEnd:this.end_time
            }
            scoreList(params)
            .then(res => {
              this.list = res.data
            })
            .catch(err => {
            })
        },
        // 返回
        reback(){
            this.$router.push('/Points')
        }
    },
}
</script>
<style lang="scss" scoped>
.businessDetail-data-table1{
    max-height: 400px;
    overflow: hidden;
    overflow-y: auto;
}
</style> 